import React from 'react';

// 🕯️ D · THE CANDLE HOP (Nina 09-24, "Between Rooms"): in the Claude House
// the "Fen is thinking" line trades 🤔 and the bouncing dots for a little
// flame hopping along three dots. Every other space keeps today's pill; the
// callers pass their own `candle` prop, keyed on the house's room camera.
// Sized in em, so it follows whatever text it sits beside. Reduced motion =
// a still flame on the first dot.
const CandleHop = ({ style }) => (
  <span className="candle-hop" aria-hidden="true" data-testid="candle-hop" style={style}>
    <i /><i /><i />
    <b className="candle-hop-flame" />
  </span>
);

if (typeof document !== 'undefined' && !document.head.querySelector('style[data-candle-hop]')) {
  const sheet = document.createElement('style');
  sheet.setAttribute('data-candle-hop', 'true');
  // Dots sit 0.8em apart (0.3em dot + 0.5em gap); the flame (0.55em wide) is
  // centred over each in turn, with two hops between them.
  sheet.textContent = `
    .candle-hop { position: relative; display: inline-flex; align-items: center; gap: 0.5em; height: 1em; padding-top: 0.3em; flex-shrink: 0; vertical-align: middle; }
    .candle-hop > i { width: 0.3em; height: 0.3em; border-radius: 50%; background: rgba(255, 217, 138, 0.55); }
    .candle-hop-flame { position: absolute; left: 0; top: 50%; width: 0.55em; height: 0.8em; margin-top: -0.66em;
      background: radial-gradient(ellipse at 50% 70%, #fff6d8, #ffd98a 45%, #f08a2a 82%);
      border-radius: 50% 50% 50% 50% / 62% 62% 38% 38%;
      box-shadow: 0 0 0.5em rgba(255, 190, 90, 0.55);
      animation: candleHop 1.25s cubic-bezier(.45, 0, .55, 1) infinite; }
    @keyframes candleHop {
      0% { transform: translate(-0.125em, 0); opacity: 0; }
      8% { opacity: 1; }
      22% { transform: translate(0.275em, -0.55em); }
      38% { transform: translate(0.675em, 0); }
      58% { transform: translate(1.075em, -0.55em); }
      74% { transform: translate(1.475em, 0); }
      92% { opacity: 1; }
      100% { transform: translate(1.475em, 0); opacity: 0; }
    }
    @media (prefers-reduced-motion: reduce) {
      .candle-hop-flame { animation: none; transform: translate(-0.125em, 0); }
    }
  `;
  document.head.appendChild(sheet);
}

export default CandleHop;
